import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MensagemService, ProgressoService, StringUtils } from 'maestro-ng';
import { SelectItem } from 'primeng/api';
import { Frm } from '../../components/frm/frm.interface';
import { FonteDadosMonitoramento } from '../../fonte-dados-monitoramento/fonte-dados-monitoramento.model';
import { FonteDadosMonitoramentoService } from '../../fonte-dados-monitoramento/fonte-dados-monitoramento.service';
import { ConversorMonitoramento } from '../../monitoramento/conversor-monitoramento.model';
import { ExtratorMonitoramento } from '../../monitoramento/extrator-monitoramento.model';
import { IrisMonitoramento } from '../../monitoramento/iris-monitoramento.model';
import { SituacaoMonitoramento } from '../../monitoramento/item-monitoramento.model';
import { PrismaMonitoramento } from '../../monitoramento/prisma-monitoramento.model';
import { OrgaoJustica } from '../../orgao-justica/orgao-justica.model';
import { OrgaoJusticaService } from '../../orgao-justica/orgao-justica.service';
import { SelectItemService } from '../../services/select-item.service';
import { Guid } from '../../util/guid';
import { FonteDados, SistemaProcessual, TipoFonteDados } from '../fonte-dados.model';
import { FonteDadosService } from '../fonte-dados.service';
import { FonteDadosEstatisticasLocal } from './../../fonte-dados-estatisticas-local/fonte-dados-estatisticas-local.model';
import { FonteDadosEstatisticasLocalService } from './../../fonte-dados-estatisticas-local/fonte-dados-estatisticas-local.service';
import { AplicacaoMonitoramentoDetalhado } from './../../monitoramento/aplicacao-monitoramento-detalhado.model';
import { FonteDadosInstancia, SISTEMAS_PROCESSUAIS_ELETRONICOS, TipoSistemaProcessual } from './../fonte-dados.model';
import { VersaoSemanticaUtils } from '../../util/versao-semantica-utils';
import { SituacaoProcessamento } from '../item-processamento.model';
import { FonteDadosMensagemErroService } from '../fonte-dados-mensagem-erro.service';
import { TimezoneService } from '../../services/timezone-service.service';

export class Monitoramento {
  conversor = new AplicacaoMonitoramentoDetalhado<ConversorMonitoramento>('Conversor');
  extrator = new AplicacaoMonitoramentoDetalhado<ExtratorMonitoramento>('Extrator');
  iris = new AplicacaoMonitoramentoDetalhado<IrisMonitoramento>('Iris');
  prisma = new AplicacaoMonitoramentoDetalhado<PrismaMonitoramento>('Prisma');
  conversorErro: string;
  extratorErro: string;
  prismaErro: string;
  irisErro: string;
}

@Component({
  selector: 'app-fonte-dados-frm',
  templateUrl: './fonte-dados-frm.component.html',
  styleUrls: ['./fonte-dados-frm.component.css'],
})
export class FonteDadosFrmComponent implements OnInit, Frm<FonteDados, number> {
  public static TAB_DADOS = 0;
  public static TAB_ESTATISTICAS = 1;
  public static TAB_DE_PARA = 2;
  public static TAB_MONITORAMENTO = 3;
  public static TAB_INFRAESTRUTURA = 4;
  public static TAB_PROXY = 5;
  public static TAB_BANCO_DADOS = 6;
  public static TAB_AUDITORIA = 7;

  public entidade: FonteDados;
  public fonteDadosEstatisticasLocal: FonteDadosEstatisticasLocal;
  public fonteDadosMonitoramento: FonteDadosMonitoramento;
  public orgaoJusticaItens: OrgaoJustica[];

  public tipoItens: SelectItem[];
  public sistemaProcessualItens: SelectItem[];
  public tipoSistemaProcessualItens: SelectItem[];
  public monitoramento = new Monitoramento();
  public instanciaItens: SelectItem[];

  public carregaDePara = false;
  public carregaAtualizacao = false;
  public tabViewIndex = FonteDadosFrmComponent.TAB_DADOS;
  public mostrarAbaBancoDados = false;
  public mostrarEstatisticaDocAtualizada = false;
  public tooltipInfoFalha = 'Os itens em falha são processados em intervalo de tempo de 1h';
  public tooltipInfoQuarentena = 'Os itens em quarentena são processados em intervalo de tempo de 1 dia';
  public tooltipInfoSuspenso = 'Os itens suspensos NÃO serão processados automaticamente';

  public selecionarTimezoneParaTodosMicroServicos = false;
  public timezoneLista: string[];
  public timezoneGlobal: string;

  constructor(
    private service: FonteDadosService,
    private orgaoJusticaService: OrgaoJusticaService,
    private fonteDadosEstatisticasLocalService: FonteDadosEstatisticasLocalService,
    private mensagemService: MensagemService,
    private progressoService: ProgressoService,
    private selectItemService: SelectItemService,
    private location: Location,
    private fonteDadosMonitoramentoService: FonteDadosMonitoramentoService,
    private fonteDadosMensagemErroService: FonteDadosMensagemErroService,
    private timezoneService: TimezoneService
  ) {}

  ngOnInit(): void {
    this.orgaoJusticaService
      .recuperarItens()
      .then((orgaosJustica) => {
        this.orgaoJusticaItens = orgaosJustica;
        this.buscarTimezones();
      })
      .catch((resposta) => {
        this.mensagemService.addErro('Erro ao recuperar os orgãos justiça', resposta.error);
      });
    this.tipoItens = this.selectItemService.getTipoFonteDados();
    this.sistemaProcessualItens = this.selectItemService.getSistemaProcessual();
    this.tipoSistemaProcessualItens = this.selectItemService.getTipoSistemaProcessual();
    this.instanciaItens = this.selectItemService.getFonteDadosInstanciaItens();

    if (this.entidade && !this.entidade.extrator) {
      this.entidade.extrator = {
        orgaoJustica: undefined,
        recebendoMensagens: false,
        sistemaProcessual: undefined,
        tipoSistemaProcessual: undefined,
        instancia: undefined,
        extratorVersao: '',
        extratorVersaoDataImplantacao: null,
        extratorTimezone: undefined,
        conversorVersao: '',
        conversorVersaoDataImplantacao: null,
        conversorTimezone: undefined,
        prismaVersao: '',
        prismaVersaoDataImplantacao: null,
        prismaTimezone: undefined,
        irisVersao: '',
        irisVersaoDataImplantacao: null,
        irisTimezone: undefined,
      };
    }
  }

  iniciarAlteracao(entidade: FonteDados): void {
    this.entidade = entidade;
  }

  iniciarAlteracaoPorId(id: number): void {
    this.progressoService.modal();
    this.service
      .recuperarPorId(id)
      .then((fonteDados) => {
        this.progressoService.fechar();
        this.iniciarAlteracao(fonteDados);
        this.validarVersaoExtrator();
      })
      .catch((resposta) => {
        this.progressoService.fechar();
        this.mensagemService.addErro('Erro ao recuperar a fonte de dados para edição', resposta.error);
      });
  }

  iniciarInsercao(entidade?: FonteDados): void {
    this.entidade =
      entidade ||
      ({
        tipo: TipoFonteDados.EXTRATOR,
      } as FonteDados);
    this.gerarSenha();
  }

  salvar(): void {
    if (this.entidade.tipo === undefined) {
      this.mensagemService.addErro('Erro de validação', 'O atributo tipo não foi definido!');
    } else if (this.entidade.tipo === TipoFonteDados.INTEGRACAO) {
      this.mensagemService.addErro('Erro', 'Ainda não foi implementado o cadastro deste tipo de fonte de dados!');
      return;
    } else if (this.entidade.tipo === TipoFonteDados.EXTRATOR) {
      if (this.entidade.extrator.orgaoJustica === undefined) {
        this.mensagemService.addErro('Erro de validação', 'O órgão de justiça não foi definido!');
        return;
      }

      if (this.entidade.extrator.sistemaProcessual === undefined) {
        this.mensagemService.addErro('Erro de validação', 'O sistema processual não foi definido!');
        return;
      }

      if (this.entidade.extrator.tipoSistemaProcessual === undefined) {
        this.mensagemService.addErro('Erro de validação', 'O tipo de sistema processual não foi definido!');
        return;
      }

      if (this.entidade.extrator.instancia === undefined) {
        this.mensagemService.addErro('Erro de validação', 'A instância não foi definida!');
        return;
      }

      if (StringUtils.isUndefinedOrEmpty(this.entidade.nome)) {
        this.mensagemService.addErro('Erro de validação', 'O nome da fonte de dados não foi definido!');
        return;
      }
    }

    const isInsercao = this.entidade.id === undefined;

    this.progressoService.modal();
    this.service
      .salvar(this.entidade)
      .then((fonteDados) => {
        fonteDados.novaSenha = this.entidade.novaSenha;

        this.entidade = fonteDados;
        this.progressoService.fechar();
        this.mensagemService.addSucesso('Sucesso', 'A fonte de dados foi salva com sucesso');

        if (isInsercao) {
          this.location.go(`/fonteDados/edicao/${this.entidade.id}`);
        }
      })
      .catch((resposta) => {
        this.progressoService.fechar();
        this.mensagemService.addErro('Erro ao salvar a fonte de dados', resposta.error);
        this.progressoService.fechar();
      });
  }

  onChangeTabView() {
    switch (this.tabViewIndex) {
      case FonteDadosFrmComponent.TAB_ESTATISTICAS:
        this.carregarEstatisticasLocais();
        break;
      case FonteDadosFrmComponent.TAB_MONITORAMENTO:
      case FonteDadosFrmComponent.TAB_INFRAESTRUTURA:
        this.carregarMonitoramento();
        break;
      case FonteDadosFrmComponent.TAB_DE_PARA:
        this.carregaDePara = true;
        break;
    }
  }

  carregarEstatisticasLocais(): void {
    this.progressoService.modal();
    this.fonteDadosEstatisticasLocalService
      .recuperarMaisRecentePorFonteDadosId(this.entidade.id)
      .then((fonteDadosEstatisticasLocal) => {
        this.fonteDadosEstatisticasLocal = fonteDadosEstatisticasLocal;
        this.progressoService.fechar();
      })
      .catch((resposta) => {
        this.mensagemService.addErro('Erro ao carregar as estatísticas', resposta.error);
        this.progressoService.fechar();
      });
  }

  carregarMonitoramento(): void {
    this.progressoService.modal();
    this.fonteDadosMonitoramentoService
      .recuperarMaisRecentePorFonteDadosId(this.entidade)
      .then((monitoramento) => {
        this.fonteDadosMonitoramento = monitoramento;
        this.verificaSucesso(monitoramento);
        this.mensagemService.addSucesso('Sucesso', 'Os dados de Monitoramento foram coletadas com sucesso!');
        this.progressoService.fechar();
      })
      .catch((resposta) => {
        this.monitoramento.conversor.atualizarComErro(resposta.error);
        this.progressoService.fechar();

        this.fonteDadosMensagemErroService.apresentarErro(
          'Erro ao coletar dados de monitoramento',
          'Dados de monitoramento',
          resposta
        );
      });
  }

  coletarMonitoramento(): void {
    this.progressoService.modal();
    this.fonteDadosMonitoramentoService
      .monitorar(this.entidade)
      .then((monitoramento) => {
        this.fonteDadosMonitoramento = monitoramento;
        this.verificaSucesso(monitoramento);
        this.mensagemService.addSucesso('Sucesso', 'Os dados de Monitoramento foram coletadas com sucesso!');
        this.progressoService.fechar();
      })
      .catch((resposta) => {
        this.progressoService.fechar();

        this.fonteDadosMensagemErroService.apresentarErro(
          'Erro ao coletar dados de monitoramento',
          'Dados de monitoramento',
          resposta
        );
      });
  }

  verificaSucesso(fonteDadosMonitoramento: FonteDadosMonitoramento) {
    if (fonteDadosMonitoramento.conversorSituacao.toString === SituacaoMonitoramento.SUCESSO.toString) {
      this.monitoramento.conversor.atualizar(
        fonteDadosMonitoramento.conversorMonitoramento,
        ConversorMonitoramento.getAtivos(fonteDadosMonitoramento.conversorMonitoramento)
      );
    } else {
      this.monitoramento.conversorErro = fonteDadosMonitoramento.conversorErro;
      this.monitoramento.conversor.atualizarComErro(fonteDadosMonitoramento.conversorErro);
    }
    if (fonteDadosMonitoramento.extratorSituacao.toString === SituacaoMonitoramento.SUCESSO.toString) {
      this.monitoramento.extrator.atualizar(
        fonteDadosMonitoramento.extratorMonitoramento,
        ExtratorMonitoramento.getAtivos(fonteDadosMonitoramento.extratorMonitoramento)
      );
    } else {
      this.monitoramento.extratorErro = fonteDadosMonitoramento.extratorErro;
      this.monitoramento.extrator.atualizarComErro(fonteDadosMonitoramento.extratorErro);
    }
    if (fonteDadosMonitoramento.irisSituacao.toString === SituacaoMonitoramento.SUCESSO.toString) {
      this.monitoramento.iris.atualizar(
        fonteDadosMonitoramento.irisMonitoramento,
        IrisMonitoramento.getAtivos(fonteDadosMonitoramento.irisMonitoramento)
      );
    } else {
      this.monitoramento.irisErro = fonteDadosMonitoramento.irisErro;
      this.monitoramento.iris.atualizarComErro(fonteDadosMonitoramento.irisErro);
    }
    if (fonteDadosMonitoramento.prismaSituacao.toString === SituacaoMonitoramento.SUCESSO.toString) {
      this.monitoramento.prisma.atualizar(
        fonteDadosMonitoramento.prismaMonitoramento,
        PrismaMonitoramento.getAtivos(fonteDadosMonitoramento.prismaMonitoramento)
      );
    } else {
      this.monitoramento.prismaErro = fonteDadosMonitoramento.prismaErro;
      this.monitoramento.prisma.atualizarComErro(fonteDadosMonitoramento.prismaErro);
    }
  }

  isExtrator(tipoFonteDados: TipoFonteDados) {
    return tipoFonteDados === TipoFonteDados.EXTRATOR;
  }

  isIntegracao(tipoFonteDados: TipoFonteDados) {
    return tipoFonteDados === TipoFonteDados.INTEGRACAO;
  }

  coletarEstatisticasLocais(): void {
    this.progressoService.modal();
    this.fonteDadosEstatisticasLocalService
      .coletarPorFonteDadosId(this.entidade.id)
      .then((fonteDadosEstatisticasLocal) => {
        this.fonteDadosEstatisticasLocal = fonteDadosEstatisticasLocal;
        this.mensagemService.addSucesso('Sucesso', 'A estatísticas locais foram coletadas com sucesso!');
        this.progressoService.fechar();
      })
      .catch((resposta) => {
        this.progressoService.fechar();

        this.fonteDadosMensagemErroService.apresentarErro(
          'Erro ao coletar as estatísticas locais',
          'Coletar estatísticas',
          resposta
        );
      });
  }

  onChangeOrgaoJustica(): void {
    this.calcularDados();
  }

  onChangeSistemaProcessual(): void {
    if (SISTEMAS_PROCESSUAIS_ELETRONICOS.includes(this.entidade.extrator.sistemaProcessual)) {
      this.entidade.extrator.tipoSistemaProcessual = TipoSistemaProcessual.ELETRONICO;
    }

    this.calcularDados();
  }

  onChangeInstancia(): void {
    this.calcularDados();
  }

  onInputNome(): void {
    this.calcularUsuario();
  }

  calcularDados() {
    let novoNome = '';
    const url = 'https://tjxx-pjexx.tjxx.jus.br/rest';

    if (this.entidade.extrator.orgaoJustica !== undefined && this.entidade.extrator.orgaoJustica !== null) {
      novoNome += this.entidade.extrator.orgaoJustica.sigla + '_';
    }

    if (this.entidade.extrator.sistemaProcessual !== undefined) {
      if (this.isSistemaPJe()) {
        novoNome += 'PJE';

        if (this.entidade.extrator.instancia !== undefined) {
          switch (this.entidade.extrator.instancia) {
            case FonteDadosInstancia.PRIMEIRO_GRAU:
              novoNome += 'PG';
              break;
            case FonteDadosInstancia.SEGUNDO_GRAU:
              novoNome += 'SG';
              break;
            case FonteDadosInstancia.TERCEIRO_GRAU:
              novoNome += 'TG';
              break;
            case FonteDadosInstancia.QUARTO_GRAU:
              novoNome += 'QG';
              break;
          }
        }
      } else {
        novoNome += this.entidade.extrator.sistemaProcessual;
      }
    }

    this.entidade.url = url.replace(url.substr(8, 4), novoNome.substr(0, novoNome.indexOf('_')).toLowerCase());
    if (novoNome.length > 5) {
      this.entidade.url = this.entidade.url.replace(url.substr(13, 5), novoNome.substr(novoNome.indexOf('_') + 1).toLowerCase());
    }

    this.entidade.nome = novoNome;
    this.calcularUsuario();
  }

  calcularUsuario(): void {
    this.entidade.usuario = this.entidade.nome.toLowerCase() + '_extrator';
  }

  isAtivo(): boolean {
    return this.entidade !== undefined;
  }

  isSistemaPJe(): boolean {
    return (
      this.isAtivo() &&
      (this.entidade.extrator.sistemaProcessual === SistemaProcessual.PJE ||
        this.entidade.extrator.sistemaProcessual === SistemaProcessual.PJE_1X ||
        this.entidade.extrator.sistemaProcessual === SistemaProcessual.PJE_JE ||
        this.entidade.extrator.sistemaProcessual === SistemaProcessual.PJE_JT)
    );
  }

  gerarSenha(): void {
    this.entidade.novaSenha = Guid.newPassword();
  }

  public validarVersaoExtrator() {
    const versaoMinima = '2.16.0-alpha.6';
    const versaoMinimaEstatisticaComunicados = '2.17.0-alpha.6';

    this.mostrarAbaBancoDados = VersaoSemanticaUtils.validarVersaoMinima(versaoMinima, this.entidade.extrator.extratorVersao);
    this.mostrarEstatisticaDocAtualizada = VersaoSemanticaUtils.validarVersaoMinima(
      versaoMinimaEstatisticaComunicados,
      this.entidade.extrator.extratorVersao
    );
  }

  isFalhaProcessamento(situacao: SituacaoProcessamento): boolean {
    return situacao === SituacaoProcessamento.FALHA_PROCESSAMENTO;
  }

  isQuarentena(situacao: SituacaoProcessamento): boolean {
    return situacao === SituacaoProcessamento.QUARENTENA;
  }

  isSuspenso(situacao: SituacaoProcessamento): boolean {
    return situacao === SituacaoProcessamento.SUSPENSO;
  }

  buscarTimezones(): void {
    this.timezoneService
      .recuperarTimezones()
      .then((timezones) => {
        this.timezoneLista = timezones;
        this.verificarTimezones();
      })
      .catch((resposta) => {
        this.mensagemService.addErro('Erro ao recuperar a lista de timezones', resposta.error);
      });
  }

  onChangeTimezone(): void {
    if (this.selecionarTimezoneParaTodosMicroServicos) {
      this.entidade.extrator.conversorTimezone = this.timezoneGlobal;
      this.entidade.extrator.extratorTimezone = this.timezoneGlobal;
      this.entidade.extrator.prismaTimezone = this.timezoneGlobal;
      this.entidade.extrator.irisTimezone = this.timezoneGlobal;
    }
  }

  verificarTimezones(): void {
    const conversorTimezone = this.entidade.extrator.conversorTimezone;
    const extratorTimezone = this.entidade.extrator.extratorTimezone;
    const prismaTimezone = this.entidade.extrator.prismaTimezone;
    const irisTimezone = this.entidade.extrator.irisTimezone;

    if (
      conversorTimezone &&
      conversorTimezone === extratorTimezone &&
      conversorTimezone === prismaTimezone &&
      conversorTimezone === irisTimezone
    ) {
      this.selecionarTimezoneParaTodosMicroServicos = true;
      this.timezoneGlobal = conversorTimezone;
    } else {
      this.selecionarTimezoneParaTodosMicroServicos = false;
    }
  }
}
